import { useMutation } from '@tanstack/react-query';

import { Boards } from '@air/api';
import { type Board } from '@air/api/types';

export const useBoardViewedMutation = () => {
  return useMutation({
    mutationFn: ({ boardId }: { boardId: Board['id'] }) => Boards.viewBoard({ boardId }),
  });
};
